export default __webpack_public_path__ + "media/images/illust-c67625ad9295aeb3e7a7848ac030be69.png";